import Config from '../Config';
import axios from 'axios';

export async function setUserRegistrationActivity(data) {
    const apiPath = `/public/set-user-registration-activity`;

    const request = {
        url: `https://${Config.DYNAMO_API_URL}${apiPath}`,
        // url: `http://localhost:3001${apiPath}`,
        host: Config.DYNAMO_API_URL,
        path: apiPath,
        method: 'POST',
        region: Config.AWS_REGION,
        service: 'execute-api',
        body: JSON.stringify(data),
        data: data,
        headers: {
            'Content-Type': 'application/json',
        },
    };
    const response = await axios(request);

    return response.data;
}